import {
  ConfirmationModal,
  PhoneVerification,
  IdVerification,
  SectionCard,
  FilterGroupLayout,
} from '@adc/ui-core'
import AuctionApplication from './auctionApplication/shell'
export type { ShellSsrHints } from './auctionApplication/shell'
import ApplicationHeader from './auctionApplication/applicationHeader'
import FocusedAuctionApplication from './auctionApplication/shellFocused'
import { useApplicationDrawers } from './auctionApplication/drawers'
import {
  useApplicationModals,
  ModalIds,
  ApplicationModalsProvider,
  ApplicationModalContext,
} from './auctionApplication/modals'
import { useApplicationQueues } from './auctionApplication/queues'
import { useApplicationSurvey } from './auctionApplication/applicationSurvey'
import {
  useApplicationContext,
  withApplicationContext,
  ApplicationContext,
  ApplicationContextProvider,
} from './auctionApplication/context'
// TODO; remove this once we're sure all usages of old notifier are done away with
import * as notifiers from './auctionApplication/notifiers'
import { withNotifications } from './auctionApplication/applicationSessionInformation'
import AuthToggle, { AuthToggleModal } from './authToggle'
import LoginForm from './authToggle/components/login'
import SignupForm from './authToggle/components/signup'
import SMSOptInToggle from './smsOptInToggle'
import PostSaveOptInModal from './postSaveOptInModal'
import NotifyMeModal from './notifyMeModal'
import {
  PaymentInstructionsContent,
  PaymentInstructionsModal,
  formatDepositAmount,
  IL_DEPOSIT_WIRE_DETAILS,
  IL_DEPOSIT_CHECK_DETAILS,
  IL_DEPOSIT_CONTACT_EMAIL,
  IL_DEPOSIT_CONTACT_PHONE,
} from './paymentInstructions'
import AdcHeader from './header'
import LogoHeader from './header/logoHeader'
import NativeAppBanner from './nativeAppBanner'
import AnnouncementBanner from './announcementBanner'
// Named helpers for SSR dismissal (cookie key, parse, fingerprint, isDismissed)
export {
  DISMISS_COOKIE_KEY as ANNOUNCEMENT_DISMISS_COOKIE_KEY,
  parseAnnouncement,
  fingerprintAnnouncement,
  isAnnouncementDismissed,
} from './announcementBanner'
import CardTab from './cardTab'
import OnboardingDrawer from './onboardingDrawer'
import * as CreditCard from './creditCard'
import AuctionApplicationProvider from './auctionApplicationProvider'
import QRCode from './qrCode'
import AdcSearch, { MAX_AMOUNT_OF_ADDRESS_RESULTS } from './search'
import ChatButton from './chatButton'
import ChatLink from './chatLink'
import SearchLocationInterestReduxWrapper, {
  SearchLocationInterest,
} from './authToggle/components/searchField'
import { ContractNotification } from './notificationTypes'
import {
  createTrusteePurchaseProfile,
  updateTrusteePurchaseProfile,
  TrusteePurchaseProfileFormFields,
  TRUSTEE_PURCHASE_PROFILE_FORM_NAME,
  TRUSTEE_PURCHASE_PROFILE_FORM_FRAGMENT,
  EntityForm,
  MultiCoBuyerForm,
  MULTI_CO_BUYER_FORM_NAME,
  EntityFormRules,
  InternationalCheckbox,
  NEW_ENTITY_FORM_NAME,
  RelationshipModal,
  matchRelationship,
  isMarriedBuyer,
  checkTwoMarriedPeople,
  getBuyerFullName,
  getBuyerId,
  findSpouse,
  getRelationship,
  generateRelationshipModalProps,
  updateMaritalStatus,
  buildRelationshipsMap,
  SPOUSE_ON_CONTRACT_NA,
  SOMEONE_ELSE,
  transformerEntityApiToFe,
  transformerEntityFeToApi,
  transformerCobuyerApiToFe,
  transformerCobuyerFeToApi,
  getMultiEntityFormFields,
  getMultiCobuyerFormFields,
  TrusteePurchaseProfileForm,
  TrusteePurchaseProfileSelectionWrapper,
} from './forms'
import TutorialTooltip, {
  TutorialTooltipGroupItem,
  TutorialTooltipActions,
  TutorialTooltipReducer,
} from './tutorialTooltip'
import Footer from './footer'
import OfferBadge from './offerBadge'
import VerificationModal from './verificationModal'
import ListingCarousel from './listingCarousel'
import {
  ListingCarouselEmbedded,
  ListingCarouselEmbeddedProps,
} from './listingCarouselEmbedded'
import ListingPhotoGrid from './listingPhotoGrid'
import { BidConfirmationContent } from './bidConfirmation'
import OfferAmountHeader from './offerAmountHeader'
import OfferSummaryHeader from './offerSummaryHeader'
import ListingInfoCard from './listingInfoCard'
import AcceptBidContent from './traditionalOfferActionsContent/acceptBidContent'
import DeclineBidContent from './traditionalOfferActionsContent/declineBidContent'
import CommunicationPreferences from './communicationPreferences'
import { getAccessibilityScript } from './auctionApplicationProvider/getAccessiblityScript'
import {
  LocationSection,
  NotesSection,
  ProgressiveCaptureContent,
  BuyingCriteriaContent,
  MatchedPropertiesCard,
  BuyingCriteriaSummaryCard,
  useProgressiveCapture,
  useBuyingCriteriaModal,
} from './buyingCriteriaForm'

export type {
  PaymentInstructionsContentProps,
  PaymentInstructionsModalProps,
  WireDetails,
  CheckDetails,
} from './paymentInstructions'

// I don't know where it's used but I'm afraid to
// break something so keeping PhoneInputField export
const { PhoneInputField } = PhoneVerification

export {
  AuctionApplicationProvider,
  getAccessibilityScript,
  AuthToggle,
  AuthToggleModal,
  LoginForm,
  SignupForm,
  BidConfirmationContent,
  ConfirmationModal,
  CommunicationPreferences,
  EntityForm,
  EntityFormRules,
  matchRelationship,
  isMarriedBuyer,
  checkTwoMarriedPeople,
  getBuyerFullName,
  getBuyerId,
  findSpouse,
  getRelationship,
  generateRelationshipModalProps,
  updateMaritalStatus,
  buildRelationshipsMap,
  SPOUSE_ON_CONTRACT_NA,
  SOMEONE_ELSE,
  transformerEntityApiToFe,
  transformerEntityFeToApi,
  transformerCobuyerApiToFe,
  transformerCobuyerFeToApi,
  createTrusteePurchaseProfile,
  updateTrusteePurchaseProfile,
  TrusteePurchaseProfileFormFields,
  TRUSTEE_PURCHASE_PROFILE_FORM_NAME,
  TRUSTEE_PURCHASE_PROFILE_FORM_FRAGMENT,
  TrusteePurchaseProfileForm,
  TrusteePurchaseProfileSelectionWrapper,
  SMSOptInToggle,
  MultiCoBuyerForm,
  MULTI_CO_BUYER_FORM_NAME,
  RelationshipModal,
  InternationalCheckbox,
  AdcHeader,
  LogoHeader,
  NativeAppBanner,
  AnnouncementBanner,
  CreditCard,
  PostSaveOptInModal,
  NotifyMeModal,
  PaymentInstructionsContent,
  PaymentInstructionsModal,
  formatDepositAmount,
  IL_DEPOSIT_WIRE_DETAILS,
  IL_DEPOSIT_CHECK_DETAILS,
  IL_DEPOSIT_CONTACT_EMAIL,
  IL_DEPOSIT_CONTACT_PHONE,
  PhoneInputField,
  QRCode,
  OnboardingDrawer,
  ChatButton,
  ChatLink,
  AdcSearch,
  NEW_ENTITY_FORM_NAME,
  MAX_AMOUNT_OF_ADDRESS_RESULTS,
  SearchLocationInterestReduxWrapper,
  CardTab,
  getMultiEntityFormFields,
  getMultiCobuyerFormFields,
  TutorialTooltipGroupItem,
  TutorialTooltipActions,
  TutorialTooltipReducer,
  TutorialTooltip,
  Footer,
  OfferBadge,
  OfferAmountHeader,
  OfferSummaryHeader,
  ContractNotification,
  ListingCarousel,
  ListingCarouselEmbedded,
  ListingCarouselEmbeddedProps,
  ListingInfoCard,
  ListingPhotoGrid,
  VerificationModal,
  AuctionApplication,
  FocusedAuctionApplication,
  ApplicationHeader,
  useApplicationContext,
  useApplicationDrawers,
  useApplicationModals,
  ModalIds,
  ApplicationModalsProvider,
  ApplicationModalContext,
  useApplicationQueues,
  useApplicationSurvey,
  withApplicationContext,
  ApplicationContext,
  ApplicationContextProvider,
  notifiers,
  withNotifications,
  AcceptBidContent,
  DeclineBidContent,
  SearchLocationInterest,
  IdVerification,
  LocationSection,
  NotesSection,
  ProgressiveCaptureContent,
  BuyingCriteriaContent,
  MatchedPropertiesCard,
  BuyingCriteriaSummaryCard,
  useProgressiveCapture,
  useBuyingCriteriaModal,
  SectionCard,
  FilterGroupLayout,
}
